import React, { FC } from 'react';
import { Box, Text } from '@chakra-ui/react';

interface Props {
  className?: string;
  label?: string;
}

export const SelectionLabel: FC<Props> = ({ className, label = 'default label' }) => {
  return (
    <Box>
      <Text className={className}>{label}</Text>
    </Box>
  );
};
